export enum LocalStorageKey {
  IMPERSONATION = 'impersonation',
  CALCULATION_MODE = 'calculationMode',
  SHOW_CONTAINER_MAP = 'showContainerMap',
  GROUP_CONTAINER_SITES = 'groupContainerSites',
}
